import {IEndPositionMessage} from '@/types/ws.types'
import {atomWithReset} from 'jotai/utils'

export interface IEndPositionsState extends IEndPositionMessage {
  teamEndTimestamp: number | undefined
}

export const endPositonsState = atomWithReset<IEndPositionsState[]>([])
